module.exports = __webpack_public_path__ + "28bd9ef19b4608aada11eb41831906ee.svg";